
    import {Component, Vue} from "vue-property-decorator";
    import router from "@/router";

    @Component
    export default class KeyLocations extends Vue {

        private headers: any[] = [];
        private keyLocations: any[] = [];
        private search: string = "";

        private mounted() {
            this.headers = [
                {value: "key", text: this.$t("key.name"), sortable: false},
                {value: "location", text: this.$tc("box.locations"), sortable: false},
            ];
            const data: any = this.$route.params?.data;
            if (!data) {
                return router.push({name: "keys"});
            }
            this.keyLocations = data.keyLocations.filter((kL) => kL?.location);
        }

        private searchCurrentValues(value, search, item) {
            return (item.key.name.includes(search) || item.location.codeName.includes(search));
        }
    }
